import React from "react";

function Img({className, src, alt, onLoad, onError}) {
  return <img className={className} src={src} alt={alt} onLoad={onLoad} onError={onError}/>;
}

export default Img;